import { render } from "./Schools.vue?vue&type=template&id=3b4131a0"
import script from "./Schools.vue?vue&type=script&lang=js"
export * from "./Schools.vue?vue&type=script&lang=js"
script.render = render

export default script